import { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
const appendElTo = (rootEl, newEl) => rootEl.appendChild(newEl);
const usePortal = ({
  rootEl = document.body,
  className = 'portal-container',
  freezeScrolling = true
}) => {
  const [modalContainer] = useState(() => {
    const el = document.createElement('div');
    el.className += className;
    return el;
  });

  // rare case where this is worth it over useEffect
  useLayoutEffect(() => {
    appendElTo(rootEl, modalContainer);
    if (freezeScrolling) {
      document.body.style.overflow = 'hidden';
    }
    return function removeElement() {
      rootEl.removeChild(modalContainer);
      if (freezeScrolling) {
        document.body.removeAttribute('style');
      }
    };
  }, []);
  return modalContainer;
};
const Portal = props => {
  const {
    children
  } = props;
  const target = usePortal(props);
  return createPortal(children, target);
};
export default Portal;